/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Keep mobile sliderule trigger states in sync for assistive technology.
  document.addEventListener('click', function(event) {
    var drawerToggle = event.target.closest('[data-drawer-toggle="hamburger"], [data-drawer-underlay]');
    if (drawerToggle) {
      document.querySelectorAll('[data-sliderule-open][aria-expanded="true"]').forEach(function(trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      return;
    }

    var openTrigger = event.target.closest('[data-sliderule-open]');
    if (openTrigger) {
      openTrigger.setAttribute('aria-expanded', 'true');
      return;
    }

    var closeTrigger = event.target.closest('[data-sliderule-close]');
    if (!closeTrigger) {
      return;
    }

    var slideruleId = closeTrigger.getAttribute('data-sliderule-close');
    if (!slideruleId) {
      return;
    }

    // Match the close control to its opener without changing menu behavior.
    var openTriggers = document.querySelectorAll('[data-sliderule-open]');
    openTriggers.forEach(function(trigger) {
      if (trigger.getAttribute('data-sliderule-open') === slideruleId) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
